import * as React from 'react';
import { FieldArray } from 'formik';
import { Input, Textarea } from 'src/components/Shared/BsInput';
import ActivitiesAutocomplete from 'src/containers/Shared/ActivitiesAutocomplete';

export default class Activities extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.renderSelected = this.renderSelected.bind(this);
  }

  public render() {
    const { values, handleChange } = this.props;
    return (
      <div>
        <div className="form-group">
          <label>Columnas</label>
          <select
            name="data.columns"
            className="form-control"
            onChange={handleChange}
            value={values.data.columns}
          >
            <option value=""></option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
          </select>
        </div>
        <FieldArray
          name="data.activities"
          render={(arrayHelpers) => {
            return (
              <div>
                <div className="form-group">
                  <label>Buscar actividad</label>
                  <ActivitiesAutocomplete
                    onSelected={(selected: any) => {
                      if (!selected) {
                        return;
                      }

                      arrayHelpers.push(selected);
                    }}
                  />
                </div>
                {
                  values.data.activities.map((d: any, i: number) =>
                    this.renderSelected(d, i, arrayHelpers)
                  )
                }
              </div>
            );
          }}
        />
      </div>
    )
  }

  private renderSelected(activity: any, index: number, arrayHelpers: any) {
    const { errors } = this.props;

    return (
      <div className="card mb-3" key={index}>
        <div className="card-body">
          <div className="row">
            <div className="col-md-2">
              <Input
                label="ID"
                readOnly={true}
                value={activity.id}
                name={`data.activities.${index}.id`}
                errors={errors}
              />
            </div>
            <div className="col-md-5">
              <Input
                label="Slug"
                readOnly={true}
                value={activity.slug}
                name={`data.activities.${index}.slug`}
                errors={errors}
              />
            </div>
          </div>
          <Input
            label="Orden"
            value={activity.order || 1}
            name={`data.activities.${index}.order`}
            onChange={this.props.handleChange}
            errors={errors}
            type="number"
          />
          <Input
            label="Nombre"
            value={activity.name}
            name={`data.activities.${index}.name`}
            onChange={this.props.handleChange}
            errors={errors}
          />
          <Textarea
            label="Descripcion corta"
            value={activity.short_description}
            name={`data.activities.${index}.short_description`}
            onChange={this.props.handleChange}
            errors={errors}
            rows={3}
          />
          {
            activity.images.map((image: any, imageIndex: number) => {
              const url = `https://fdyla7kvx3.execute-api.sa-east-1.amazonaws.com/dev/o/${image.bucket}/${image.name}`;
              return (
                <span key={imageIndex}>
                  <a href={url} target="_blank">Imagen {imageIndex + 1 }</a> | &nbsp;
                </span>
              )
            })
          }
        </div>
        <div className="card-footer">
          <div className="text-right">
            <button
              type="button"
              className="btn btn-sm btn-danger"
              onClick={(e) => {
                e.preventDefault();
                arrayHelpers.remove(index);
              }}
            >
              <i className="fa fa-trash"></i>
            </button>
          </div>
        </div>
      </div>

    );
  };
}



// WEBPACK FOOTER //
// ./src/containers/Module/Types/Activities.tsx